// invoiceSlice.ts
import { Invoice } from '../types/invoiceForm';
import createGenericSlice from './createGenericSlice';

// This will generate a slice specifically for invoices
const invoiceSlice = createGenericSlice<Invoice>('invoices');

export const { addItem, editItem, deleteItem, copyItem, clearItems } = invoiceSlice.actions;

export default invoiceSlice.reducer;
